import { Column, Columns } from "ui-kit/components-branded/index"
import "modules/PsyCatalog/common/Filters/onPopState"
import { CitiesDropdown } from "modules/PsyCatalog/common/Filters/CitiesDropdown"
import { SessionTimeIntervalsDropdown } from "modules/PsyCatalog/common/Filters/SessionTimeIntervalsDropdown"
import { CompetenceDropdown } from "modules/PsyCatalog/common/Filters/CompetenceDropdown"
import { MethodsDropdown } from "modules/PsyCatalog/common/Filters/MethodsDropdown"
import { ExpressFilter } from "modules/PsyCatalog/common/Filters/ExpressFilter"
import { FormOfWorkSelector } from "modules/PsyCatalog/common/Filters/FormOfWorkSelector"
import { PriceSelector } from "modules/PsyCatalog/common/Filters/PriceSelector"
import { useShowPrice } from "utils/hooks/useShowPrice"

export function BasicFilters() {
    const showPrice = useShowPrice()

    return (
        <>
            <Columns className="mt-1">
                <Column className="is-one-third">
                    <CitiesDropdown />
                </Column>
                <Column className="is-one-third">
                    <FormOfWorkSelector />
                </Column>
                <Column className="is-one-third">
                    <SessionTimeIntervalsDropdown />
                </Column>
            </Columns>
            <Columns>
                <Column className="is-half">
                    <CompetenceDropdown />
                </Column>
                <Column className="is-half">
                    <MethodsDropdown />
                </Column>
            </Columns>
            {showPrice && (
                <Columns>
                    <Column>
                        <PriceSelector />
                    </Column>
                </Columns>
            )}
            <Columns>
                <Column>
                    <ExpressFilter />
                </Column>
            </Columns>
        </>
    )
}
